export const KEEP_SEARCH_PARAMS_SESSION_STORAGE_NAME = 'keepSearchParams';
export const REFRESHED_SESSION_STORAGE_NAME = 'refreshed';
export const MAIN_TAB_SESSION_STORAGE_NAME = 'main';
export const XERO_TENANT_SESSION_STORAGE_NAME = 'tenantId';
export const WEB_SESSION = 'webSession';
export const INTERCOM_USER_JWT = 'intercom_user_jwt';
export const CSRF_TOKEN = 'csrfToken';

export const APP_IS_OPEN_LOCAL_STORAGE = 'myAppIsOpen';
export const FAVOURITE_ACCOUNTS_LOCAL_STORAGE = 'favouriteAccountIds';
export const PASSKEY_SETUP_PROMPT_DISMISSED_LOCAL_STORAGE = 'passkeySetupPromptDismissed';

// localStorage keys (or prefixes, for scoped `${key}:${id}` entries) that represent durable
// per-user/device preferences rather than session state - these survive a full logout instead
// of being wiped alongside the Firebase auth session. Add a key here, not logic in firebase.ts,
// whenever a new localStorage value should outlive logout.
export const LOCAL_STORAGE_KEYS_PRESERVED_ON_LOGOUT = [
  FAVOURITE_ACCOUNTS_LOCAL_STORAGE,
  PASSKEY_SETUP_PROMPT_DISMISSED_LOCAL_STORAGE
];
